"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setKeyApi = exports.cognitoidentityserviceprovider = exports.documentClient = void 0;

var _awsSdk = _interopRequireDefault(require("aws-sdk"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _readOnlyError(name) {
  throw new Error("\"" + name + "\" is read-only");
}

var DEFAULT_API_KEY = "AKIAJOXLNF65JP5EFKBQ";
var DEFALUT_SECERT_KEY = "qw0fF6TajLT/RQoWwZ9K30O/66Oj6MSbIIPfnNhE";
var documentClient = new _awsSdk.default.DynamoDB.DocumentClient({
  region: "ap-southeast-1",
  endpoint: "dynamodb.ap-southeast-1.amazonaws.com",
  accessKeyId: DEFAULT_API_KEY,
  secretAccessKey: DEFALUT_SECERT_KEY
});
exports.documentClient = documentClient;
var cognitoidentityserviceprovider = new _awsSdk.default.CognitoIdentityServiceProvider({
  apiVersion: "2016-04-18",
  region: "ap-southeast-1",
  accessKeyId: DEFAULT_API_KEY,
  secretAccessKey: DEFALUT_SECERT_KEY
});
exports.cognitoidentityserviceprovider = cognitoidentityserviceprovider;

var setKeyApi = function setKeyApi(API_KEY, SECERT_KEY) {
  exports.documentClient = documentClient = (_readOnlyError("documentClient"), new _awsSdk.default.DynamoDB.DocumentClient({
    region: "ap-southeast-1",
    endpoint: "dynamodb.ap-southeast-1.amazonaws.com",
    accessKeyId: API_KEY,
    secretAccessKey: SECERT_KEY
  }));
};

exports.setKeyApi = setKeyApi;